import { Button, Typography } from "@material-ui/core";
import { ModelBundle } from "../types/List";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GetAppIcon from "@material-ui/icons/GetApp";

export default function (props: { List: ModelBundle }) {
    const List = props.List;

    return (
        <div className="fixed bottom-0 z-20 w-full p-5 flex gap-5 px-10  bg-gray-dark justify-between">
            <div className="flex gap-3 items-center">
                <Button variant="outlined" color="primary" href={`/l/${List.PublicID}?edit`}>
                    Edit
                </Button>

                <div className="flex gap-3">
                    <VisibilityIcon/>
                    <Typography variant="body1">{List.Views}</Typography>
                </div>

                <div className="flex gap-3">
                    <GetAppIcon/>
                    <Typography variant="body1">{List.Downloads}</Typography>
                </div>
            </div>

            <div className="h-full">
                <div className={`px-6 py-1 h-full rounded flex justify-center items-center ${List.Visibility === 'Public' ? 'bg-green-700' : 'bg-gray-light'}`}>
                    <Typography variant="body1" className="text-white">{List.Visibility}</Typography>
                </div>
            </div>
        </div>

    )
}